import type { CityConfig } from "@/pages/city-template/types";

export const neenahConfig: CityConfig = {
  city: "Neenah",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "neenah",
  route: "/cities/neenah",
  title: "Emergency & Expedited Passport Services Neenah WI | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Neenah, WI — as fast as 24 hours. No Neenah passport agency. Fast Passport Center couriers to the Chicago Passport Agency, about 170 miles south. A+ BBB rated. Serving Kimberly-Clark professionals, Fox Valley families, and Winnebago County travelers heading abroad for business, study, or vacation.",
  h1: "Emergency & Expedited Passport Services in Neenah, WI",
  heroSubtitle: "Neenah is a cornerstone of Wisconsin's Fox Valley, home to Kimberly-Clark's global headquarters and part of the thriving Fox Cities region along Lake Winnebago. Fast Passport Center's registered couriers deliver your documents to the Chicago Passport Agency so you get a new or renewed passport as fast as 24 hours — whether you're a Kimberly-Clark executive heading to an international board meeting, a Fox Valley family planning a European vacation, or a Neenah-area professional with global business obligations.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Neenah%20Wisconsin%20downtown%20historic%20district%20along%20Wisconsin%20Avenue%20with%20charming%20brick%20storefronts%20and%20the%20Neenah%20Clock%20Tower%20under%20warm%20summer%20afternoon%20sunlight%2C%20Fox%20Valley%20small%20city%20architecture%20with%20Lake%20Winnebago%20shoreline%20visible%20in%20background%2C%20professional%20wide%20angle%20photography%20with%20clean%20composition%20and%20natural%20midwestern%20colors&width=1800&height=700&seq=neenah-wi-hero-001&orientation=landscape",
  heroImageAlt: "Neenah Wisconsin downtown with Clock Tower and Lake Winnebago shoreline",
  geoPosition: "44.1858;-88.4626",
  geoPlacename: "Neenah, Wisconsin",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 170 miles from Neenah — about 2 hours 45 minutes via I-41/I-94",
  },
  nearbyCitiesZips: [
    { name: "Neenah", zips: "54956, 54957" },
    { name: "Menasha", zips: "54952" },
    { name: "Appleton", zips: "54911, 54913, 54914, 54915" },
    { name: "Oshkosh", zips: "54901, 54902, 54904" },
    { name: "Kaukauna", zips: "54130" },
    { name: "Sherwood", zips: "54169" },
    { name: "Hilbert", zips: "54129" },
    { name: "Greenville", zips: "54942" },
    { name: "Hortonville", zips: "54944" },
    { name: "New London", zips: "54961" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Chicago Passport Agency — about 170 miles from Neenah via I-41" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Fox Valley Hub", desc: "Serving Neenah, Menasha, Appleton, Oshkosh, and all Winnebago County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Neenah case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Milwaukee WI", route: "/cities/milwaukee" },
    { name: "Expedited passport in Madison WI", route: "/cities/madison-wi" },
    { name: "Urgent passport in Neenah WI", route: "/cities/neenah" },
    { name: "Wisconsin passport hub", route: "/states/wisconsin" },
    { name: "Fast passport in Appleton WI", route: "/cities/appleton" },
    { name: "Expedited passport in Oshkosh WI", route: "/cities/oshkosh" },
    { name: "Emergency passport in Green Bay WI", route: "/cities/green-bay" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Neenah remotely via secure courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency — approximately 170 miles south via I-41 and I-94. Neenah's location in the heart of the Fox Valley, with excellent highway access to both I-41 and major shipping routes, makes overnight courier routing highly efficient. Our dedicated agents ensure Fox Valley travelers never need to make the nearly 3-hour drive to Chicago for passport processing.",
  fpcOfficeDistance: "Serving all of the Fox Valley and Winnebago County",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Neenah, Menasha, Appleton, Oshkosh, and the Fox Valley corridor. From Kimberly-Clark corporate executives to Fox Valley families, we help Winnebago County travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Neenah and nearby communities including Menasha, Appleton, Oshkosh, Kaukauna, Sherwood, and the entire Fox Valley region.",
  howItWorksIntro: "Most Neenah travelers complete everything online and ship documents overnight. At approximately 170 miles from Chicago, Fast Passport Center provides fast courier turnaround for Fox Valley residents — eliminating the nearly 3-hour drive to the Chicago Passport Agency.",
  mistakesIntro: "Neenah travelers, including Kimberly-Clark professionals and Fox Valley families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Neenah and Fox Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Neenah? Here are the most common ones we hear from Fox Valley and Winnebago County travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://wisconsindot.gov/Pages/online-srvcs/dmv-driver-license.aspx",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Kimberly-Clark international business travel",
        "Perfect for Fox Valley family vacations",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from ATW or GRB",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins in Chicago",
        "Life-or-death emergencies only",
        "170 miles to Chicago (2 hours 45 minutes via I-41/I-94)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Neenah is 170 miles from the Chicago Passport Agency — our courier service saves Fox Valley travelers the 3-hour I-41 drive.",
      bullets: ["Fox Valley coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Fox Valley",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Neenah adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Neenah and Winnebago County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Neenah and Fox Valley.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Neenah and Fox Valley residents with DS-64 form guidance and courier routing to Chicago.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Winnebago County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Neenah and Fox Valley residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Neenah WI", description: "Urgent passport processing for Neenah, WI travelers via Chicago Passport Agency courier — 170 miles from Neenah." },
    { name: "Passport Renewal Neenah WI", description: "Fast passport renewal for Neenah and Winnebago County, Wisconsin residents." },
    { name: "New Passport Neenah WI", description: "First-time passport application assistance for Neenah and Fox Valley area residents." },
    { name: "Lost Passport Neenah WI", description: "Passport replacement for lost or stolen passports for Neenah and Fox Valley residents." },
    { name: "Child Passport Neenah WI", description: "Minor passport services for Neenah and Winnebago County families." },
    { name: "Name Change Passport Neenah WI", description: "Passport name change service for Neenah, WI residents." },
  ],
  testimonials: [
    {
      name: "David M.",
      location: "Kimberly-Clark Executive",
      rating: 5,
      text: "Senior VP at KC needing to fly to our UK office with 6 days notice. My passport had expired 3 months prior. Fast Passport Center renewed it in 3 business days. The Chicago courier service was flawless and my dedicated agent kept me informed at every step.",
      service: "Emergency Renewal",
    },
    {
      name: "Jennifer & Mark S.",
      location: "Neenah, WI",
      rating: 5,
      text: "Fox Valley couple planning our 25th anniversary trip to Italy. Both of us needed renewals and we had 4 weeks. Fast Passport Center handled both applications simultaneously — received both passports in 7 business days. Our agent was incredibly reassuring throughout.",
      service: "Dual Renewal",
    },
    {
      name: "Tom R.",
      location: "Menasha, WI",
      rating: 5,
      text: "Sales director covering the Midwest who won a President's Club trip to Tokyo with 10 days notice. Realized my passport had expired. Fast Passport Center expedited a renewal in 4 business days. I made the trip and had an incredible experience.",
      service: "Expedited Renewal",
    },
    {
      name: "The K Family",
      location: "Neenah, WI",
      rating: 5,
      text: "Family of five planning a summer trip to Ireland. Three renewals and two first-time child passports needed. Fast Passport Center managed all five applications effortlessly — every passport arrived in 9 business days. The children were so excited to see their first passports.",
      service: "Family Applications",
    },
  ],
  facilities: [
    {
      id: "ne-1",
      name: "Neenah Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 W Franklin Ave",
      city: "Neenah",
      state: "WI",
      zip: "54956",
      phone: "(920) 725-6912",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Neenah — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Neenah and Winnebago County residents. Appointment required. Located on Franklin Avenue in downtown Neenah.",
      icon: "ri-mail-line",
    },
    {
      id: "ne-2",
      name: "Menasha Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "84 Racine St",
      city: "Menasha",
      state: "WI",
      zip: "54952",
      phone: "(920) 725-3021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Menasha — adjacent to Neenah",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient option for Menasha and southern Neenah residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "ne-3",
      name: "Appleton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 W Schindler Pl",
      city: "Appleton",
      state: "WI",
      zip: "54914",
      phone: "(920) 733-3865",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Appleton — 7 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service USPS passport acceptance facility in Appleton. Larger facility with more appointment availability than Neenah.",
      icon: "ri-mail-line",
    },
    {
      id: "ne-4",
      name: "Oshkosh Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1025 W 20th Ave",
      city: "Oshkosh",
      state: "WI",
      zip: "54902",
      phone: "(920) 236-8701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Oshkosh — 12 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Winnebago County residents. Services Oshkosh and surrounding communities.",
      icon: "ri-mail-line",
    },
    {
      id: "ne-5",
      name: "Winnebago County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "415 Jackson St",
      city: "Oshkosh",
      state: "WI",
      zip: "54901",
      phone: "(920) 236-4848",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Oshkosh — 12 miles south",
      website: "https://www.co.winnebago.wi.us",
      websiteLabel: "Winnebago County Government",
      notes: "County clerk passport acceptance services. Convenient for all Winnebago County residents. Located in the county administration building.",
      icon: "ri-government-line",
    },
    {
      id: "ne-6",
      name: "Kaukauna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 W 2nd St",
      city: "Kaukauna",
      state: "WI",
      zip: "54130",
      phone: "(920) 766-2451",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kaukauna — 10 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town option for northeastern Fox Valley residents. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "170 miles — 2 hour 45 minute drive via I-41/I-94, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming Appleton Has a Passport Agency",
      description: "Fox Valley residents often assume the larger city of Appleton must have a passport agency. The closest passport agency is in Chicago — 170 miles south. No passport agency exists anywhere in the Fox Valley or Green Bay region, leaving Neenah travelers dependent on courier services for emergency processing.",
    },
    {
      icon: "ri-calendar-line",
      title: "Kimberly-Clark Executives Not Planning Ahead for International Board Travel",
      description: "Neenah's largest employer, Kimberly-Clark, has global operations spanning dozens of countries. KC professionals often receive short-notice international travel assignments. We see executives who assume their passport is current — only to discover it expired during a busy quarter — with a board meeting in London in 10 days.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking From ATW",
      description: "Fox Valley travelers often book international flights from Appleton International Airport (ATW) months in advance without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Neenah residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
    {
      icon: "ri-global-line",
      title: "Confusing TSA PreCheck and REAL ID With Passport Requirements",
      description: "Fox Valley travelers sometimes confuse TSA PreCheck or Wisconsin REAL ID with international travel documentation. Neither TSA PreCheck nor a REAL ID-compliant driver's license can be used for international air travel. A valid U.S. passport is always required for flights leaving the United States.",
    },
    {
      icon: "ri-cloud-line",
      title: "Underestimating Winter Travel Delays for Chicago Agency Appointments",
      description: "Neenah residents who do secure a Chicago Passport Agency appointment often underestimate winter driving conditions. The I-41/I-94 corridor between the Fox Valley and Chicago can be treacherous from November through March. A missed appointment means starting the process over — and potentially missing your trip entirely.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Neenah, Menasha, or Appleton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Chicago Passport Agency — 170 miles south via I-41." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Neenah or Fox Valley address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Neenah from the Chicago passport agency?",
      a: "Neenah is approximately 170 miles from the Chicago Passport Agency at 230 S Dearborn St, Suite 380 — about a 2 hour 45 minute drive south via I-41 and I-94. However, the Chicago agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments often fill 2–3 weeks in advance.",
    },
    {
      q: "Does Neenah, WI have its own passport agency?",
      a: "No. Neenah does not have a passport agency. The closest passport agency is the Chicago Passport Agency, about 170 miles south. Neenah only has passport acceptance facilities — the Neenah Post Office at 130 W Franklin Ave — which can accept DS-11 applications but cannot process or expedite them.",
    },
    {
      q: "Where do Neenah travelers typically fly internationally?",
      a: "Neenah travelers typically fly from Appleton International Airport (ATW, just 10 miles north), Green Bay Austin Straubel Airport (GRB, about 40 miles northeast), or drive to Milwaukee Mitchell (MKE) or Chicago O'Hare (ORD) for direct international flights.",
    },
    {
      q: "How fast can I get an emergency passport in Neenah?",
      a: "Emergency processing is typically 24–48 hours for Neenah residents. Given Neenah's location in the Fox Valley with excellent I-41 access and major UPS/FedEx shipping corridors, overnight courier routing to Chicago is highly efficient. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Neenah?",
      a: "Walgreens at 1008 S Green Bay Rd and CVS Pharmacy at 901 S Green Bay Rd in Neenah both offer passport photo services. The UPS Store at 1255 W Wisconsin Ave also provides photos. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "I work at Kimberly-Clark — can you handle last-minute international business travel?",
      a: "Absolutely. We specialize in helping Kimberly-Clark and Fox Valley corporate professionals with urgent international business travel. Emergency processing delivers passports in as fast as 24–48 hours. Our courier service to Chicago saves you the 3-hour drive and the stress of securing a government appointment.",
    },
    {
      q: "How do I renew my passport in Neenah?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Neenah Post Office for an in-person DS-11 application.",
    },
    {
      q: "Does the Neenah Post Office take walk-in passport appointments?",
      a: "The Neenah Post Office at 130 W Franklin Ave accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (920) 725-6912 to schedule.",
    },
    {
      q: "Can Fast Passport Center help Menasha and Appleton residents too?",
      a: "Absolutely. We serve all of the Fox Valley region including Neenah, Menasha, Appleton, Oshkosh, Kaukauna, Sherwood, Hilbert, Greenville, Hortonville, and New London. Residents of surrounding communities never need to drive to Neenah or Chicago for service — our courier handles everything.",
    },
    {
      q: "Can I use my Wisconsin REAL ID instead of a passport for international travel?",
      a: "No. A Wisconsin REAL ID-compliant driver's license can only be used for domestic air travel and entering federal facilities. It cannot be used for international air travel. You must have a valid U.S. passport to fly internationally.",
    },
    {
      q: "What's the fastest way to get a passport in the Fox Valley?",
      a: "Fast Passport Center is the fastest option for Fox Valley residents. Our courier service to the Chicago Passport Agency achieves 24–48 hour emergency processing and 2–9 business day standard expedited. Self-service USPS takes 8–11 weeks and the nearest agency appointment (Chicago, 170 miles away) requires scheduling weeks in advance.",
    },
    {
      q: "Is the Menasha Post Office faster than the Neenah Post Office for passport applications?",
      a: "Both the Neenah Post Office and the Menasha Post Office serve as passport acceptance facilities with identical processing capabilities. Neither facility can expedite processing — they only accept applications for standard mail-in processing. That's where Fast Passport Center's courier service comes in, providing the only expedited option for Fox Valley residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Neenah", address: "1008 S Green Bay Rd, Neenah, WI 54956", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Neenah", address: "901 S Green Bay Rd, Neenah, WI 54956", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Neenah", address: "1255 W Wisconsin Ave, Neenah, WI 54956", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "Walgreens — Appleton", address: "729 W Northland Ave, Appleton, WI 54914", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart Photo — Neenah", address: "1300 S Lynndale Dr, Appleton, WI 54914", hours: "Mon–Sun: 7AM–9PM" },
    { name: "FedEx Office — Appleton", address: "4301 W Wisconsin Ave, Appleton, WI 54913", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — Appleton", address: "711 W Clairemont Ave, Appleton, WI 54914", hours: "Mon–Fri: 8:30AM–4:45PM", note: "Closest full DMV service center to Neenah. REAL ID, driver's license, and state ID services for Fox Valley and Winnebago County residents.", featured: true },
    { name: "WI DMV — Oshkosh", address: "1900 Oshkosh Ave, Oshkosh, WI 54902", hours: "Mon–Fri: 8:30AM–4:45PM", note: "Serves southern Winnebago County and Oshkosh area. About 12 miles south of Neenah.", featured: false },
    { name: "WI DMV — Green Bay East", address: "942 S Military Ave, Green Bay, WI 54304", hours: "Mon–Fri: 8:30AM–4:45PM", note: "Larger DMV center. Serves Brown County and northern Fox Valley. About 40 miles north of Neenah.", featured: false },
  ],
  airports: [
    {
      code: "ATW",
      name: "Appleton International Airport",
      distance: "10 miles north of Neenah",
      address: "W6390 Challenger Dr, Appleton, WI 54914",
      note: "Fox Valley's primary airport — just 15 minutes from Neenah. Domestic routes via major carriers with connections to international hubs. The most convenient departure point for Fox Valley travelers.",
      flightUrl: "https://atwairport.com/",
      flightLabel: "ATW Airport",
      featured: true,
    },
    {
      code: "GRB",
      name: "Green Bay Austin Straubel International Airport",
      distance: "40 miles northeast of Neenah",
      address: "2077 Airport Dr, Green Bay, WI 54313",
      note: "Northeastern Wisconsin's airport with domestic routes. About 45 minutes via I-41. Alternative for northern Fox Valley travelers.",
      flightUrl: "https://www.flygrb.com/",
      flightLabel: "GRB Airport",
      featured: false,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "100 miles south of Neenah",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Wisconsin's largest airport with extensive domestic and some international routes. About 1 hour 30 minutes via I-41. Gateway to Chicago area connections.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "170 miles south of Neenah",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway with direct flights worldwide. About 2 hours 45 minutes via I-41/I-94. Best option for direct international flights from the Fox Valley region.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified Wisconsin birth certificates from the WI Department of Health Services Vital Records Office. Available by mail, online, or in person.", url: "https://www.dhs.wisconsin.gov/vitalrecords" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the WI Department of Health Services Vital Records Office. Serving Winnebago County and Fox Valley residents.", url: "https://www.dhs.wisconsin.gov/vitalrecords" },
    { icon: "ri-heart-pulse-line", label: "Marriage Certificate", desc: "Request certified marriage certificates from the Winnebago County Register of Deeds in Oshkosh. Marriage records are maintained by the county where the ceremony took place.", url: "https://www.co.winnebago.wi.us/" },
    { icon: "ri-file-copy-2-line", label: "Divorce Decree", desc: "Obtain certified divorce decrees through the Winnebago County Clerk of Courts. Divorce records are maintained by the court where the decree was granted.", url: "https://www.co.winnebago.wi.us/" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Wisconsin birth, death, marriage, and divorce certificates online through VitalChek for Neenah and Fox Valley residents.", url: "https://www.vitalchek.com/" },
  ],
};